export default __webpack_public_path__ + "static/media/man-and-brain.368e2277.jpeg";